// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5529":"8d507242","9457":"8d507242"}[chunkId] + ".chunk.css";
};